import { styled } from '@mui/material'
import { RichTextEditor } from './RichTextEditor'
import { intl } from '../../../../../i18n'
import { useDiscussionActions } from './hooks/useDiscussionActions'

interface NewThreadFormProps {
  projectUuid: string
  versionPageUuid: string
  discussionUuid?: string
  onClose: () => void
  onRefresh?: () => void
}

export const NewThreadForm = ({
  projectUuid,
  versionPageUuid,
  discussionUuid,
  onClose,
  onRefresh,
}: NewThreadFormProps) => {
  const { handleCreateThread } = useDiscussionActions({
    versionPageUuid,
    discussionUuid,
    onClose,
    onRefresh,
  })

  const handleSubmit = async (content: string) => {
    await handleCreateThread(content)
  }

  return (
    <FormContainer>
      <FormTitle>
        {intl.formatMessage({ id: 'discussion.new.title' })}
      </FormTitle>
      <RichTextEditor
        placeholder={intl.formatMessage({ id: 'discussion.new.placeholder' })}
        onSubmit={handleSubmit}
        onCancel={onClose}
        showCancel={true}
        submitLabel={intl.formatMessage({ id: 'discussion.new.submit' })}
        projectUuid={projectUuid}
      />
    </FormContainer>
  )
}

const FormContainer = styled('div')({
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  padding: '16px',
  backgroundColor: '#ffffff',
  marginBottom: '16px',
})

const FormTitle = styled('h4')({
  margin: '0 0 12px 0',
  fontSize: '14px',
  fontWeight: 600,
})
